module.exports = __webpack_public_path__ + "/images/logo-fr-bebe-au-naturel.4e671b6.png";